import React from 'react'
import { Badge } from '@/components/ui/badge'
import { MapPin, Building2 } from 'lucide-react'
import { LocationCard } from '@/components/LocationCard'
import { useDesaDetail } from '@/hooks/use-desa-public'

export default function DesaLokasiPage() {
  const { data: desa } = useDesaDetail()

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-cyan-50 to-indigo-50">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-blue-600 via-blue-700 to-indigo-600 overflow-hidden">
        <div className="absolute inset-0 bg-black/20"></div>
        
        <div className="relative container mx-auto px-6 py-20">
          <div className="max-w-4xl">
            <div className="flex items-center gap-3 mb-6">
              <div className="p-3 bg-white/20 rounded-xl backdrop-blur-sm">
                <MapPin className="w-6 h-6 text-white" />
              </div>
              <Badge variant="secondary" className="bg-white/20 text-white border-white/30 hover:bg-white/30">
                Lokasi Desa
              </Badge>
              <span className="text-white/80">•</span>
              <span className="text-white/90">Peta & Navigasi</span>
            </div>

            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 leading-tight">
              Lokasi Desa
            </h1>

            <p className="text-xl text-white/90 mb-8 leading-relaxed max-w-3xl">
              Peta lokasi kantor desa, informasi geografis, dan panduan navigasi untuk mencapai desa
            </p>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="container mx-auto px-6 py-12 space-y-12">
        {/* Location Section */}
        <section>
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold bg-gradient-to-r from-gray-900 via-blue-800 to-gray-900 bg-clip-text text-transparent mb-4">
              Peta Lokasi
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Lokasi kantor desa dan informasi geografis untuk navigasi dan akses masyarakat
            </p>
          </div>

          {/* Location Section */}
          {desa && (desa.latitude && desa.longitude) ? (
            <LocationCard desa={desa} />
          ) : (
            <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
              <div className="p-8">
                <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-8 text-center">
                  <Building2 className="w-16 h-16 text-yellow-600 mx-auto mb-6" />
                  <h3 className="text-xl font-bold text-yellow-800 mb-3">
                    Data Lokasi Belum Tersedia
                  </h3>
                  <p className="text-yellow-700 leading-relaxed max-w-md mx-auto">
                    Koordinat geografis kantor desa sedang dalam proses verifikasi dan akan segera ditampilkan.
                  </p>
                </div>
              </div>
            </div>
          )}
        </section>
        
        {/* Information Card */}
        <section>
          <div className="bg-gradient-to-r from-blue-50 via-cyan-50 to-indigo-50 border border-blue-200 shadow-lg rounded-2xl">
            <div className="p-8">
              <div className="text-center">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  Lokasi Kantor Desa
                </h3>
                <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
                  Peta lokasi kantor desa disediakan untuk memudahkan navigasi dan akses masyarakat ke kantor desa dengan informasi geografis yang akurat
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}